import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, eur } from "@/lib/api";

const STATUS_LABELS = {
  pagamento_pendente: { label: "Pagamento pendente", cls: "brand-border border brand-muted" },
  pending: { label: "Pagamento pendente", cls: "brand-border border brand-muted" },
  in_preparation: { label: "Em preparação", cls: "bg-[#8C6A3D] text-white" },
  confirmed: { label: "Em preparação", cls: "bg-[#8C6A3D] text-white" },
  shipped: { label: "Enviada", cls: "bg-[#4A6B53] text-white" },
  completed: { label: "Concluída", cls: "bg-[#4A6B53] text-white" },
  cancelled: { label: "Cancelada", cls: "bg-[#9E4747] text-white" },
};

const PAYMENT_LABELS = {
  paid: { label: "Paga", cls: "bg-[#4A6B53] text-white" },
  pending: { label: "Pendente", cls: "brand-border border brand-muted" },
};

const METHOD_LABELS = { mbway: "MB WAY", transfer: "Transferência bancária" };

export default function Profile() {
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders/me")
      .then(({ data }) => setOrders(data))
      .catch(() => setOrders([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="max-w-5xl mx-auto px-6 lg:px-12 py-16" data-testid="page-profile">
      <p className="label-sm mb-3">Conta</p>
      <h1 className="font-serif text-4xl lg:text-5xl brand-text mb-2">Olá, {user?.name}</h1>
      <p className="brand-muted mb-12">{user?.email}</p>

      <section>
        <h2 className="font-serif text-2xl brand-text mb-6">As minhas encomendas</h2>

        {loading ? (
          <p className="brand-muted">A carregar...</p>
        ) : orders.length === 0 ? (
          <p className="brand-muted">Ainda não tem encomendas.</p>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => {
              const st = STATUS_LABELS[o.status] || STATUS_LABELS.pagamento_pendente;
              const pay = PAYMENT_LABELS[o.payment_status] || PAYMENT_LABELS.pending;
              const method = METHOD_LABELS[o.payment_method] || o.payment_method || "—";
              return (
                <div key={o.id} className="brand-surface p-6 border brand-border" data-testid={`order-${o.id}`}>
                  <div className="flex flex-wrap justify-between items-start gap-3 mb-4">
                    <div>
                      <p className="label-sm">Encomenda</p>
                      <p className="font-serif text-2xl brand-text" data-testid={`order-number-${o.id}`}>
                        #{o.order_number ?? o.id.slice(0, 8)}
                      </p>
                      <p className="text-xs brand-muted mt-1">
                        {new Date(o.created_at).toLocaleString("pt-PT")}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="label-sm">Total</p>
                      <p className="font-serif text-2xl brand-text">{eur(o.amount)}</p>
                      <p className="text-xs brand-muted mt-1">{method}</p>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-4">
                    <span className={`text-xs px-3 py-1 ${st.cls}`} data-testid={`order-status-${o.id}`}>
                      {st.label}
                    </span>
                    <span className={`text-xs px-3 py-1 ${pay.cls}`} data-testid={`order-payment-${o.id}`}>
                      Pagamento: {pay.label}
                    </span>
                  </div>

                  <div className="flex gap-2 flex-wrap">
                    {(o.items || []).map((it) => (
                      <div key={it.product_id + it.name} className="flex items-center gap-2 brand-bg p-2 border brand-border">
                        <img src={it.image_url} alt="" className="w-10 h-12 object-cover" />
                        <div className="text-xs">
                          <p className="brand-text">{it.name}</p>
                          <p className="brand-muted">×{it.quantity} · {eur(it.line_total ?? it.price * it.quantity)}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>

      <button onClick={logout} className="btn-ghost mt-12" data-testid="profile-logout">Terminar sessão</button>
    </main>
  );
}
